export default __webpack_public_path__ + "static/media/feature_graphic.e2399731.svg";